import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-maintenance",
  "use": "icon-soc-maintenance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-maintenance\">\r\n<g transform=\"translate(-64.698 -113.571) scale(1.221818)\">\r\n<path d=\"M672 160c-96 0-176 64-208 152l-240 240c-16-8-48-8-80 24s-32 64-16 96l112 112c32 16 72 8 96-16l240-240c88-32 152-112 152-208 0-32-8-64-24-88L608 288c16 24 24 48 24 80 0 88-72 160-160 160-24 0-48-8-72-16l-48 48c40 24 88 40 136 40 128 0 232-104 232-232 0-40-8-80-24-112L672 160z\" />\r\n  <path d=\"M224 672l-64 64 128 128 64-64-128-128z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-maintenance.svg
// module id = tYJt
// module chunks = 396